import React from 'react';
import { PaymentMethodsPreloadCacheProvider } from './PaymentMethodsPreloadCacheProvider';

export const PaymentMethodsProviders = ({ children }: any) => {
	return <PaymentMethodsPreloadCacheProvider>{children}</PaymentMethodsPreloadCacheProvider>;
};
